import { create } from 'zustand';
import { getFixedFeeAmount } from '@/api/tournament/tournamentApi';

interface FeeState {
  fixedFeeAmount: number | null;
  isLoading: boolean;
  error: string | null;
  isInitialized: boolean;
  hasError: boolean;
  fetchFixedFeeAmount: () => Promise<void>;
  reset: () => void;
}

export const useFeeStore = create<FeeState>((set, get) => ({
  fixedFeeAmount: null,
  isLoading: false,
  error: null,
  isInitialized: false,
  hasError: false,

  fetchFixedFeeAmount: async () => {
    // Don't auto-fetch if already initialized
    if (get().isInitialized) {
      return;
    }

    set({ isLoading: true, error: null, hasError: false });
    try {
      const amount = await getFixedFeeAmount();
      set({
        fixedFeeAmount: amount,
        isLoading: false,
        isInitialized: true,
        error: null,
        hasError: false,
      });
    } catch (error) {
      console.error('Error fetching fixed fee amount:', error);
      set({
        error: 'Failed to load fixed fee amount',
        isLoading: false,
        isInitialized: true,
        hasError: true,
      });
    }
  },

  reset: () => {
    set({
      fixedFeeAmount: null,
      isLoading: false,
      error: null,
      isInitialized: false,
      hasError: false,
    });
  },
}));
